(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lookbook-row-shoppable"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__lookbookInit) return;
    window.__lookbookInit = true;

    /* ---------- shop-the-look drawer ---------- */
    var drawerRefs = null;

    function buildDrawer() {
      var backdrop = document.createElement('div');
      backdrop.className = 'lookbook-drawer-backdrop';
      backdrop.hidden = true;
      backdrop.addEventListener('click', closeDrawer);

      var drawer = document.createElement('aside');
      drawer.className = 'lookbook-drawer';
      drawer.setAttribute('role', 'dialog');
      drawer.setAttribute('aria-modal', 'true');
      drawer.hidden = true;
      drawer.innerHTML =
        '<div class="lookbook-drawer__header">' +
          '<span class="lookbook-drawer__title">Shop The Look</span>' +
          '<button type="button" class="lookbook-drawer__close" aria-label="Close">&times;</button>' +
        '</div>' +
        '<div class="lookbook-drawer__body"></div>';
      drawer.querySelector('.lookbook-drawer__close').addEventListener('click', closeDrawer);

      document.body.appendChild(backdrop);
      document.body.appendChild(drawer);

      return { backdrop: backdrop, drawer: drawer };
    }

    function getDrawer() {
      if (!drawerRefs) drawerRefs = buildDrawer();
      return drawerRefs;
    }

    function drawerOpen() {
      return drawerRefs && !drawerRefs.drawer.hidden;
    }

    function openDrawer(template, title) {
      var d = getDrawer();
      d.drawer.setAttribute('aria-label', title || 'Shop The Look');
      d.drawer.querySelector('.lookbook-drawer__title').textContent = title || 'Shop The Look';
      var body = d.drawer.querySelector('.lookbook-drawer__body');
      body.innerHTML = '';
      body.appendChild(template.content.cloneNode(true));
      body.querySelectorAll('a[href]').forEach(function (a) {
        a.setAttribute('target', '_blank');
        a.setAttribute('rel', 'noopener');
      });
      d.backdrop.hidden = false;
      d.drawer.hidden = false;
      requestAnimationFrame(function () {
        d.backdrop.classList.add('is-open');
        d.drawer.classList.add('is-open');
      });
      document.body.style.overflow = 'hidden';
      d.drawer.querySelector('.lookbook-drawer__close').focus();
    }

    function closeDrawer() {
      if (!drawerRefs) return;
      var backdrop = drawerRefs.backdrop;
      var drawer = drawerRefs.drawer;
      backdrop.classList.remove('is-open');
      drawer.classList.remove('is-open');
      var onEnd = function () {
        drawer.hidden = true;
        backdrop.hidden = true;
        drawer.removeEventListener('transitionend', onEnd);
      };
      drawer.addEventListener('transitionend', onEnd);
      if (!lightboxOpen()) document.body.style.overflow = '';
    }

    /* ---------- lightbox gallery ---------- */
    var lb = null;
    var triggers = [];
    var current = 0;
    var currentTpl = null;
    var currentTitle = '';

    function buildLightbox() {
      var root = document.createElement('div');
      root.className = 'lookbook-lightbox';
      root.hidden = true;
      root.innerHTML =
        '<img class="lookbook-lightbox__logo" alt="" hidden>' +
        '<button type="button" class="lookbook-lightbox__close" aria-label="Close">&times;</button>' +
        '<div class="lookbook-lightbox__viewport"><div class="lookbook-lightbox__track"></div></div>' +
        '<div class="lookbook-lightbox__controls">' +
          '<button type="button" class="lookbook-lightbox__nav lookbook-lightbox__nav--prev" aria-label="Previous">&#8249;</button>' +
          '<button type="button" class="lookbook-lightbox__nav lookbook-lightbox__nav--next" aria-label="Next">&#8250;</button>' +
        '</div>' +
        '<div class="lookbook-lightbox__footer">' +
          '<button type="button" class="lookbook-lightbox__shop">Shop The Look</button>' +
        '</div>';
      document.body.appendChild(root);

      var refs = {
        root: root,
        viewport: root.querySelector('.lookbook-lightbox__viewport'),
        track: root.querySelector('.lookbook-lightbox__track'),
        prev: root.querySelector('.lookbook-lightbox__nav--prev'),
        next: root.querySelector('.lookbook-lightbox__nav--next'),
        close: root.querySelector('.lookbook-lightbox__close'),
        shop: root.querySelector('.lookbook-lightbox__shop'),
        logo: root.querySelector('.lookbook-lightbox__logo')
      };

      refs.close.addEventListener('click', closeLightbox);
      refs.prev.addEventListener('click', function () { goTo(current - 1, true); });
      refs.next.addEventListener('click', function () { goTo(current + 1, true); });
      refs.shop.addEventListener('click', function () {
        if (currentTpl) openDrawer(currentTpl, currentTitle);
      });

      var startX = null;
      refs.viewport.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
      }, { passive: true });
      refs.viewport.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) goTo(current + (dx < 0 ? 1 : -1), true);
        startX = null;
      });

      return refs;
    }

    function getLightbox() {
      if (!lb) lb = buildLightbox();
      return lb;
    }

    function lightboxOpen() {
      return lb && !lb.root.hidden;
    }

    function measureImage() {
      if (!lb) return;
      var slide = lb.track.children[current];
      var img = slide && slide.querySelector('img');
      if (!img) return;
      var w = img.getBoundingClientRect().width;
      if (w > 0) lb.root.style.setProperty('--lb-img-w', w + 'px');
    }

    function openLightbox(list, index) {
      triggers = list;
      var l = getLightbox();
      var section = list[0] && list[0].closest('.shopify-section');
      var logoEl = section && section.querySelector('.lookbook[data-lb-logo]');
      var logoUrl = logoEl && logoEl.getAttribute('data-lb-logo');
      if (logoUrl) { l.logo.src = logoUrl; l.logo.hidden = false; } else { l.logo.hidden = true; }
      l.track.innerHTML = '';
      triggers.forEach(function (t) {
        var slide = document.createElement('div');
        slide.className = 'lookbook-lightbox__slide';
        var img = document.createElement('img');
        img.src = t.getAttribute('data-full');
        var inner = t.querySelector('img');
        img.alt = inner ? inner.alt : '';
        slide.appendChild(img);
        img.addEventListener('load', measureImage);
        l.track.appendChild(slide);
      });
      var multi = triggers.length > 1;
      l.prev.hidden = !multi;
      l.next.hidden = !multi;
      l.root.hidden = false;
      goTo(index, false);
      requestAnimationFrame(function () { l.root.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
    }

    function goTo(i, animate) {
      var l = getLightbox();
      current = (i + triggers.length) % triggers.length;
      if (animate === false) {
        l.track.style.transition = 'none';
        l.track.style.transform = 'translateX(' + (-current * 100) + '%)';
        requestAnimationFrame(function () { l.track.style.transition = ''; });
      } else {
        l.track.style.transform = 'translateX(' + (-current * 100) + '%)';
      }
      var tpl = triggers[current].parentElement.querySelector('template.lookbook__products');
      if (tpl) {
        currentTpl = tpl;
        currentTitle = triggers[current].getAttribute('data-drawer-title') || 'Shop The Look';
        l.shop.hidden = false;
      } else {
        currentTpl = null;
        l.shop.hidden = true;
      }
      measureImage();
    }

    function closeLightbox() {
      if (!lb) return;
      if (drawerOpen()) closeDrawer();
      lb.root.classList.remove('is-open');
      var root = lb.root;
      var onEnd = function () {
        root.hidden = true;
        root.removeEventListener('transitionend', onEnd);
      };
      root.addEventListener('transitionend', onEnd);
      document.body.style.overflow = '';
    }

    /* ---------- events ---------- */
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-lookbook-trigger]');
      if (!trigger) return;
      e.preventDefault();
      var scope = trigger.closest('.shopify-section') || document;
      var list = Array.prototype.slice.call(scope.querySelectorAll('[data-lookbook-trigger]'));
      openLightbox(list, list.indexOf(trigger));
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (drawerOpen()) closeDrawer();
        else if (lightboxOpen()) closeLightbox();
        return;
      }
      if (lightboxOpen() && !drawerOpen()) {
        if (e.key === 'ArrowLeft') goTo(current - 1, true);
        else if (e.key === 'ArrowRight') goTo(current + 1, true);
      }
    });

    /* ---------- added feedback + cart handling for the theme quick-add inside the drawer ---------- */
    function setCartCount(count) {
      var nodes = document.querySelectorAll('[data-js-cart-count], .header--cart-count, [data-cart-count], .cart-count');
      nodes.forEach(function (n) { n.textContent = count; });
    }

    function showAddedToast() {
      if (!drawerRefs) return;
      var drawer = drawerRefs.drawer;
      var toast = drawer.querySelector('.lookbook-drawer__toast');
      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'lookbook-drawer__toast';
        drawer.appendChild(toast);
      }
      toast.textContent = 'Added to cart';
      requestAnimationFrame(function () { toast.classList.add('is-visible'); });
      clearTimeout(toast.__t);
      toast.__t = setTimeout(function () { toast.classList.remove('is-visible'); }, 2000);
    }

    function suppressCartDrawer() {
      // Theme opens its cart drawer (.quick-cart__wrapper.active) after an add.
      // While the lookbook is open, keep it shut and rely on the toast instead.
      var until = Date.now() + 1500;
      (function tick() {
        document.querySelectorAll('.quick-cart__wrapper.active').forEach(function (w) {
          w.classList.remove('active');
        });
        if (Date.now() < until && drawerOpen()) requestAnimationFrame(tick);
      })();
    }

    function onLookbookAdd() {
      showAddedToast();
      suppressCartDrawer();
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { setCartCount(cart.item_count); })
        .catch(function () {});
    }

    var __origFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0];
      var urlStr = (typeof url === 'string') ? url : (url && url.url) || '';
      var p = __origFetch.apply(this, arguments);
      if (urlStr.indexOf('/cart/add') !== -1) {
        p.then(function (res) {
          if (res && res.ok && drawerOpen()) onLookbookAdd();
        }).catch(function () {});
      }
      return p;
    };

    window.addEventListener('resize', measureImage);
  })();
  } catch(e) { console.error(e); }
})();

})();
